import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInput } from '@angular/material/input';

import { MatSelectModule } from '@angular/material/select';
import { FormInputComponent, FieldValueInterface } from '../../../../tokens-and-interfaces';
import { InlineEditService } from '../../inline-edit.service';
import { stopChromeAutofill } from '../stop-chrome-autofill';

@Component({
  templateUrl: './opportunity-name.component.html',
  styleUrls: ['../renderers.scss'],
  imports: [CommonModule, MatSelectModule, GalaxyFormFieldModule, TranslateModule, MatInput, ReactiveFormsModule],
})
export class OpportunityNameComponent extends FormInputComponent {
  disableAutoComplete: string = stopChromeAutofill();

  _fieldId = '';
  set fieldId(fieldId: string) {
    this._fieldId = fieldId;
  }
  get fieldId(): string {
    return this._fieldId;
  }
  _control: FormControl<string> = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required],
  });
  set control(control: FormControl<string>) {
    this._control = control;
    this.control.setValue(control.value || '');
    this.control.setValidators(Validators.required);
  }
  get control(): UntypedFormControl {
    return this._control;
  }

  _label = '';
  set label(label: string) {
    this._label = label;
  }
  get label(): string {
    return this._label;
  }

  constructor(private readonly inlineEditService: InlineEditService) {
    super();
  }

  set formGroup(group: UntypedFormGroup) {
    // do nothing
  }

  get hasModification(): boolean {
    return this._control.dirty;
  }

  get value(): FieldValueInterface {
    return {
      fieldId: this.fieldId,
      stringValue: this.control.value,
    };
  }

  saveField(): void {
    this.inlineEditService.saveInlineEdit(this.objectType, [
      {
        fieldId: this.fieldId,
        stringValue: this.control.value,
      },
    ]);
  }
}
